import Model, { attr } from '@ember-data/model';
import { Type } from '@warp-drive/core-types/symbols';
import {
  calculateAdr,
  calculateCostToRoomRevenueRatio,
  calculateNetAdr,
  calculateNetRevenueToRoomRevenueRatio,
} from 'lumen/utils/net-revenue/metrics';
import type { NetRevenueReference } from 'lumen/utils/net-revenue/types';

export default class NetRevenueCostProfile extends Model {
  [Type] = 'net-revenue/cost-profile' as const;

  @attr('net-revenue-money') declare cost: number | null;
  @attr('string') declare name: string | null;

  @attr('net-revenue-money') declare netRevenue: number;
  @attr('net-revenue-references') declare references: NetRevenueReference[];
  @attr('number') declare roomNights: number;
  @attr('net-revenue-money') declare roomRevenue: number;

  get adr(): number {
    return calculateAdr(this.roomRevenue, this.roomNights) ?? 0;
  }

  get costPercent(): number {
    return (
      calculateCostToRoomRevenueRatio(this.cost ?? 0, this.roomRevenue) ?? 0
    );
  }

  get isRemaining(): boolean {
    return this.name === null;
  }

  get netAdr(): number {
    return calculateNetAdr(this.netRevenue, this.roomNights) ?? 0;
  }

  get netRevenuePercent(): number {
    return (
      calculateNetRevenueToRoomRevenueRatio(
        this.netRevenue,
        this.roomRevenue,
      ) ?? 0
    );
  }

  referenceByType(type: string): NetRevenueReference | undefined {
    return this.references?.find((reference) => reference.type === type);
  }
}
